import { OrdersViewType } from "@lib/ShiOneClient";
import { OrderViewType } from "@widgets/ecommerce/types/OrderViewType";

export const getOrdersViewType = (
  view?: OrderViewType,
): OrdersViewType | undefined => {
  switch (view) {
    case OrderViewType.My:
      return OrdersViewType.My;
    case OrderViewType.Storefront:
      return OrdersViewType.Storefront;
    case OrderViewType.All:
      return OrdersViewType.All;
    case OrderViewType.PendingApprovals:
      return OrdersViewType.PendingApprovals;
    default:
      return undefined;
  }
};
